import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";
import {
  IBranch,
  IDivision,
  IHoliday,
  IFeatureOverride,
  IBranchCreatePayload,
  IBranchUpdatePayload,
  IBranchDeletePayload,
  IDivisionCreatePayload,
  IDivisionUpdatePayload,
  IDivisionDeletePayload,
  IHolidayCreatePayload,
  IHolidayUpdatePayload,
  IHolidayDeletePayload,
  IFeatureOverrideSetPayload,
  IFeatureOverrideRemovePayload,
} from "../../../types/api/company-config";

// ── Branches ──────────────────────────────────────────────────────────────────

export async function listBranches(qData: QData): Promise<AxiosResponse<TResponseWithQData<IBranch[]>>> {
  return axios.get(API_ENDPOINTS.BRANCH_LIST, { params: qData });
}

export async function branchDetail(id: number): Promise<AxiosResponse<TResponse<IBranch>>> {
  return axios.get(`${API_ENDPOINTS.BRANCH_DETAIL}/${id}`);
}

export async function createBranch(data: IBranchCreatePayload): Promise<AxiosResponse<TResponse<IBranch>>> {
  return axios.post(API_ENDPOINTS.BRANCH_CREATE, data);
}

export async function updateBranch(data: IBranchUpdatePayload): Promise<AxiosResponse<TResponse<IBranch>>> {
  return axios.post(API_ENDPOINTS.BRANCH_UPDATE, data);
}

export async function deleteBranch(data: IBranchDeletePayload): Promise<AxiosResponse<TResponse<null>>> {
  return axios.post(API_ENDPOINTS.BRANCH_DELETE, data);
}

// ── Divisions ─────────────────────────────────────────────────────────────────

export async function listDivisions(qData: QData): Promise<AxiosResponse<TResponseWithQData<IDivision[]>>> {
  return axios.get(API_ENDPOINTS.DIVISION_LIST, { params: qData });
}

export async function divisionDetail(id: number): Promise<AxiosResponse<TResponse<IDivision>>> {
  return axios.get(`${API_ENDPOINTS.DIVISION_DETAIL}/${id}`);
}

export async function createDivision(data: IDivisionCreatePayload): Promise<AxiosResponse<TResponse<IDivision>>> {
  return axios.post(API_ENDPOINTS.DIVISION_CREATE, data);
}

export async function updateDivision(data: IDivisionUpdatePayload): Promise<AxiosResponse<TResponse<IDivision>>> {
  return axios.post(API_ENDPOINTS.DIVISION_UPDATE, data);
}

export async function deleteDivision(data: IDivisionDeletePayload): Promise<AxiosResponse<TResponse<null>>> {
  return axios.post(API_ENDPOINTS.DIVISION_DELETE, data);
}

// ── Holidays ──────────────────────────────────────────────────────────────────

export async function listHolidays(qData: QData): Promise<AxiosResponse<TResponseWithQData<IHoliday[]>>> {
  return axios.get(API_ENDPOINTS.HOLIDAY_LIST, { params: qData });
}

export async function upcomingHolidays(params?: Record<string, any>): Promise<AxiosResponse<TResponse<IHoliday[]>>> {
  return axios.get(API_ENDPOINTS.HOLIDAY_UPCOMING, { params });
}

export async function holidayDetail(id: number): Promise<AxiosResponse<TResponse<IHoliday>>> {
  return axios.get(`${API_ENDPOINTS.HOLIDAY_DETAIL}/${id}`);
}

export async function createHoliday(data: IHolidayCreatePayload): Promise<AxiosResponse<TResponse<IHoliday>>> {
  return axios.post(API_ENDPOINTS.HOLIDAY_CREATE, data);
}

export async function updateHoliday(data: IHolidayUpdatePayload): Promise<AxiosResponse<TResponse<IHoliday>>> {
  return axios.post(API_ENDPOINTS.HOLIDAY_UPDATE, data);
}

export async function deleteHoliday(data: IHolidayDeletePayload): Promise<AxiosResponse<TResponse<null>>> {
  return axios.post(API_ENDPOINTS.HOLIDAY_DELETE, data);
}

// ── Feature Overrides ─────────────────────────────────────────────────────────

export async function listFeatureOverrides(qData: QData): Promise<AxiosResponse<TResponseWithQData<IFeatureOverride[]>>> {
  return axios.get(API_ENDPOINTS.FEATURE_OVERRIDE_LIST, { params: qData });
}

export async function featureOverrideByKey(key: string): Promise<AxiosResponse<TResponse<IFeatureOverride>>> {
  return axios.get(`${API_ENDPOINTS.FEATURE_OVERRIDE_KEY}/${key}`);
}

export async function setFeatureOverride(data: IFeatureOverrideSetPayload): Promise<AxiosResponse<TResponse<IFeatureOverride>>> {
  return axios.post(API_ENDPOINTS.FEATURE_OVERRIDE_SET, data);
}

export async function removeFeatureOverride(data: IFeatureOverrideRemovePayload): Promise<AxiosResponse<TResponse<null>>> {
  return axios.post(API_ENDPOINTS.FEATURE_OVERRIDE_REMOVE, data);
}
